// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3icXZ","comment":"styles_comment__2gE7B"};